import { memo } from 'react';

// Skeleton para o banner do curso (desktop)
export const CourseBannerSkeleton = memo(() => {
    return (
        <div className="card card-flag rounded-5 w-100 d-none d-md-block overflow-hidden mb-4 border-none">
            <div className="position-relative" style={{ height: '300px', backgroundColor: '#e9ecef' }}>
                <div className="position-absolute w-100 h-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}></div>
                <div className="skeleton-shimmer"></div>
            </div>
        </div>
    );
});

CourseBannerSkeleton.displayName = 'CourseBannerSkeleton';

// Skeleton para o header mobile do curso
export const CourseHeaderMobileSkeleton = memo(() => {
    return (
        <div className="d-md-none mb-3">
            <div className="position-relative rounded-4 overflow-hidden mb-3">
                <div style={{ height: '200px', backgroundColor: '#e9ecef', position: 'relative' }}>
                    <div className="position-absolute w-100 h-100 top-0 start-0"
                        style={{ background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.5) 80%)' }}>
                    </div>
                    <div className="skeleton-shimmer"></div>
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <div style={{ width: '150px', height: '38px', backgroundColor: '#e9ecef', borderRadius: '50rem', position: 'relative' }}>
                    <div className="skeleton-shimmer"></div>
                </div>
                <div style={{ width: '120px', height: '38px', backgroundColor: '#e9ecef', borderRadius: '50rem', position: 'relative' }}>
                    <div className="skeleton-shimmer"></div>
                </div>
            </div>
        </div>
    );
});

CourseHeaderMobileSkeleton.displayName = 'CourseHeaderMobileSkeleton';

// Skeleton para card de módulo no formato mobile (lista horizontal)
const ModuleListItemSkeleton = memo(({ showProgressBar = false }) => {
    return (
        <div className="col-12 mb-3">
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden" style={{ border: '1px solid #e9ecef' }}>
                <div className="row g-0">
                    <div className="col-12 position-relative">
                        <div style={{ height: '150px', backgroundColor: '#e9ecef', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                            <div className="position-absolute w-100 h-100 top-0 start-0"
                                style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)' }}>
                            </div>
                            {/* Badge skeleton */}
                            <div className="position-absolute top-0 end-0 m-2">
                                <div style={{ width: '80px', height: '24px', backgroundColor: 'rgba(255,255,255,0.75)', borderRadius: '50rem', position: 'relative' }}>
                                    <div className="skeleton-shimmer"></div>
                                </div>
                            </div>
                            {/* Título skeleton */}
                            <div className="position-absolute bottom-0 start-0 p-3 w-100">
                                <div style={{ width: '60%', height: '20px', backgroundColor: 'rgba(255,255,255,0.8)', borderRadius: '4px', position: 'relative' }}>
                                    <div className="skeleton-shimmer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card-body px-3 py-2" style={{ backgroundColor: '#f8f9fa' }}>
                            <div className="d-flex justify-content-between align-items-center">
                                {showProgressBar && (
                                    <div className="d-flex align-items-center flex-grow-1 me-3">
                                        <div className="progress flex-grow-1" style={{ height: '6px', borderRadius: '3px', backgroundColor: '#e9ecef', position: 'relative' }}>
                                            <div className="skeleton-shimmer"></div>
                                        </div>
                                        <div style={{ width: '35px', height: '12px', backgroundColor: '#e9ecef', borderRadius: '3px', marginLeft: '8px', position: 'relative' }}>
                                            <div className="skeleton-shimmer"></div>
                                        </div>
                                    </div>
                                )}
                                <div className="d-flex gap-2 align-items-center justify-content-between w-100">
                                    <div className="btn rounded-3" style={{ width: '100px', height: '32px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                                        <div className="skeleton-shimmer"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

ModuleListItemSkeleton.displayName = 'ModuleListItemSkeleton';

// Skeleton para card de módulo no formato desktop (grid)
const ModuleGridItemSkeleton = memo(({ showProgressBar = false }) => {
    return (
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-4 mt-4">
            <div className="mb-4">
                <div className="card" style={{ border: '1px solid #e9ecef', boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)' }}>
                    <div className="card border-0">
                        <div style={{ height: '20vh', backgroundColor: '#e9ecef', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                            <div className="card-img-overlay gradient-white border-bottom-radius-0 d-flex flex-column justify-content-end p-3">
                                <div style={{ width: '70%', height: '24px', backgroundColor: 'rgba(255, 255, 255, 0.72)', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                                    <div className="skeleton-shimmer"></div>
                                </div>
                                <div style={{ width: '40%', height: '16px', backgroundColor: 'rgba(255, 255, 255, 0.59)', borderRadius: '4px', position: 'relative' }}>
                                    <div className="skeleton-shimmer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body" style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #e9ecef' }}>
                        {showProgressBar && (
                            <div className="progress w-100 mb-3" style={{ backgroundColor: '#e9ecef', height: '24px', position: 'relative' }}>
                                <div className="skeleton-shimmer" style={{ height: '100%', width: '60%' }}></div>
                            </div>
                        )}
                        <div className="d-flex justify-content-between">
                            <div className="btn rounded" style={{ width: '100%', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                                <div className="skeleton-shimmer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

ModuleGridItemSkeleton.displayName = 'ModuleGridItemSkeleton';

// Componente que renderiza múltiplos skeletons de módulos
export const ModuleSkeletons = ({ count = 6, showProgressBar = false, isMobile = false }) => {
    const skeletons = Array.from({ length: count }, (_, index) => 
        isMobile ? (
            <ModuleListItemSkeleton key={`skeleton-mobile-${index}`} showProgressBar={showProgressBar} />
        ) : (
            <ModuleGridItemSkeleton key={`skeleton-desktop-${index}`} showProgressBar={showProgressBar} />
        )
    );

    return <>{skeletons}</>;
};

export default ModuleSkeletons;
